import { getItem } from 'app/components/analytics'

export const trackConfirmReturn = (refundMethod, returnItems, orderNumber, locale) => {
    const items = returnItems?.map((item) => {
        const attributes = {
            exchangeType: item.returnOrExchange,
            returnReason: item.selectedReturnCode,
        }

        return getItem({ item, attributes })
    })
    const { currency: orderCurrency, country: countryCode } = locale

    return {
        event: 'refund-exchange - confirm order',
        eventEffect: 'user confirm refund-exchange',
        attributes: {
            orderNumber,
            refundMethod,
            orderCurrency,
            countryCode,
        },
        return: {
            item: items,
        },
    }
}
